"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$postFeedMembers = exports.$patchFeedMembers = exports.$getFeedMembers = exports.$deleteFeedMembers = void 0;
var _oldHttpClient = require("../../apiClient/oldHttpClient");
var base = '/v5/feeds';
var $deleteFeedMembers = (_feed, _user) => (0, _oldHttpClient.apiClient)({
  method: 'delete',
  url: "".concat(base, "/").concat(_feed, "/members/").concat(_user)
});
exports.$deleteFeedMembers = $deleteFeedMembers;
var $getFeedMembers = _feed => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: "".concat(base, "/").concat(_feed, "/members")
});
exports.$getFeedMembers = $getFeedMembers;
var $patchFeedMembers = (_feed, _user, status) => (0, _oldHttpClient.apiClient)({
  method: 'patch',
  url: "".concat(base, "/").concat(_feed, "/members/").concat(_user),
  body: {
    status
  }
});
exports.$patchFeedMembers = $patchFeedMembers;
var $postFeedMembers = (_feed, _users) => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(base, "/").concat(_feed, "/members"),
  body: {
    _users
  }
});
exports.$postFeedMembers = $postFeedMembers;